export default __webpack_public_path__ + "static/media/add-more.b66f25a1.svg";